import { render } from "./ModelsView.vue?vue&type=template&id=6c7fe85e&scoped=true"
import script from "./ModelsView.vue?vue&type=script&lang=js"
export * from "./ModelsView.vue?vue&type=script&lang=js"

import "./ModelsView.vue?vue&type=style&index=0&id=6c7fe85e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7fe85e"]])

export default __exports__